/**
 * Accordion Component
 * Handles expandable/collapsible content sections with smooth animations
 */

/**
 * Toggles accordion section open/closed state
 * @param {string} contentId - The ID of the accordion content element
 */
window.toggleAccordion = function toggleAccordion(contentId) {
	const content = document.getElementById(contentId)
	const chevron = document.getElementById('chevron-' + contentId.replace('accordion-', ''))
	const button = chevron ? chevron.closest('button') : null

	// Validate required elements
	if (!content || !chevron || !button) {
		console.warn(`Accordion elements not found for ID: ${contentId}`)
		return
	}

	const isHidden = content.classList.contains('hidden')

	if (isHidden) {
		// Open accordion
		openAccordion(content, chevron, button)
	} else {
		// Close accordion
		closeAccordion(content, chevron, button)
	}
}

/**
 * Opens an accordion section
 * @param {HTMLElement} content - Content element
 * @param {HTMLElement} chevron - Chevron icon element
 * @param {HTMLElement} button - Button element
 */
function openAccordion(content, chevron, button) {
	content.classList.remove('hidden')
	chevron.classList.add('rotate-180')
	button.setAttribute('aria-expanded', 'true')

	// Dispatch custom event for other components that might need to react
	content.dispatchEvent(
		new CustomEvent('accordion:opened', {
			detail: { contentId: content.id },
		})
	)
}

/**
 * Closes an accordion section
 * @param {HTMLElement} content - Content element
 * @param {HTMLElement} chevron - Chevron icon element
 * @param {HTMLElement} button - Button element
 */
function closeAccordion(content, chevron, button) {
	content.classList.add('hidden')
	chevron.classList.remove('rotate-180')
	button.setAttribute('aria-expanded', 'false')

	// Dispatch custom event for other components that might need to react
	content.dispatchEvent(
		new CustomEvent('accordion:closed', {
			detail: { contentId: content.id },
		})
	)
}

/**
 * Initialize all accordions on the page
 * Can be called to set up keyboard navigation or other enhancements
 */
function initializeAccordions() {
	// Handle buttons with data-accordion-toggle attribute
	const accordionButtons = document.querySelectorAll('[data-accordion-toggle]')

	accordionButtons.forEach(button => {
		// Add keyboard support
		button.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				const contentId = button.getAttribute('data-accordion-toggle')
				if (contentId) {
					toggleAccordion(contentId)
				}
			}
		})
	})

	// Handle buttons with onclick="toggleAccordion(...)" (backward compatibility)
	const onclickButtons = document.querySelectorAll('[onclick*="toggleAccordion"]')

	onclickButtons.forEach(button => {
		// Add keyboard support for onclick buttons
		button.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				// Extract content ID from onclick attribute
				const onclickAttr = button.getAttribute('onclick')
				const match = onclickAttr.match(/toggleAccordion\(['"]([^'"]+)['"]\)/)
				if (match && match[1]) {
					toggleAccordion(match[1])
				}
			}
		})
	})
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeAccordions)
} else {
	initializeAccordions()
}
